import { Tab, TabContext, TabList, TabPanel } from '@global-engineering-shared/gweb-material-ui';
import React from 'react';

import { Toggle } from 'components/CheckboxToggle/types/Toggle';
import useStyles from 'features/Health/components/FrameHealthTabs/FrameHealthTabs.styles';
import { FrameHealthTab } from 'features/Health/components/FrameHealthTabs/types/frameHealthTab';
import FrameHealthChartContainer from 'features/Health/containers/FrameHealthChartContainer';

type FrameHealthTabsProps = {
  tabs: FrameHealthTab[];
  toggles: Toggle[];
};

const FrameHealthTabs = ({ tabs, toggles }: FrameHealthTabsProps) => {
  const [selectedTab, setSelectedTab] = React.useState('1');
  const classes = useStyles();
  const handleChange = (_event: any, newValue: string) => {
    setSelectedTab(newValue);
  };

  return (
    <TabContext value={selectedTab}>
      <TabList onChange={handleChange} className={classes.list}>
        {tabs.map((tabValue, index) => (
          <Tab key={index} label={tabValue.label} value={tabValue.value} className={classes.tab} />
        ))}
      </TabList>
      {tabs.map((frameHealthTab, index) => (
        <TabPanel key={index} value={frameHealthTab.value} className={classes.panel}>
          <FrameHealthChartContainer
            frameHealthDimension={frameHealthTab.frameHealthDimension}
            toggles={toggles}
          />
        </TabPanel>
      ))}
    </TabContext>
  );
};

export default FrameHealthTabs;
